"use strict";

/**
 * @namespace
 */
gc.gis.ui = gc.gis.ui || {};

